import { html, LitElement, svg } from "lit";
import { customElement, property } from "lit/decorators.js";

import styles from "./resource-slide.css";

import type { SlideViewMode } from "../slide/slide";

// TODO support more icons/intents
const icon = svg`<svg class="icon" aria-hidden="true" focusable="false" role="img" viewBox="0 0 448 512" style="--icon-color:var(--slide-accent-color); --icon-size:var(--size-6);"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M448 336v-288C448 21.49 426.5 0 400 0H96C42.98 0 0 42.98 0 96v320c0 53.02 42.98 96 96 96h320c17.67 0 32-14.33 32-31.1c0-11.72-6.607-21.52-16-27.1v-81.36C441.8 362.8 448 350.2 448 336zM143.1 128h192C344.8 128 352 135.2 352 144C352 152.8 344.8 160 336 160H143.1C135.2 160 128 152.8 128 144C128 135.2 135.2 128 143.1 128zM143.1 192h192C344.8 192 352 199.2 352 208C352 216.8 344.8 224 336 224H143.1C135.2 224 128 216.8 128 208C128 199.2 135.2 192 143.1 192zM384 448H96c-17.67 0-32-14.33-32-32c0-17.67 14.33-32 32-32h288V448z"></path></svg>`;

@customElement("bp-resource-slide")
export class ResourceSlide extends LitElement {
  static styles = styles;

  @property()
  authors: Array<string> = [];

  @property({ attribute: "view-mode" })
  viewMode?: SlideViewMode = "default";

  render() {
    return html`
      <div class="resource-slide ${this.viewMode}">
        <div class="content-container">
          <div class="content">
            <div class="icon-container">${icon}</div>
            <div class="resource-info">
              <div class="resource-title">
                <slot></slot>
              </div>
              <ul class="resource-authors">
                ${this.authors.map(
                  (author) =>
                    html`<li class="author" key="${author}">${author}</li>`,
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-resource-slide": ResourceSlide;
  }
}
